import { statsData } from '@/mocks/homepage';

export default function StatsSection() {
  return (
    <section className="w-full py-14 bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-background-50/20 rounded-xl">
                <i className={`${stat.icon} text-background-50 text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}